
/* styles */
require("!!style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d7e98b02!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./tab-store-item.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./tab-store-item.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d7e98b02!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./tab-store-item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/new-tabbar/src/tab-store-item.vue
// module id = 557
// module chunks = 0